import PerfisPage from '@/modules/app/perfis/pages/PerfisPage.vue';

const routes = [{
    path: 'perfis',
    name: 'perfis',
    component: PerfisPage
}];

export default routes;